import StepWizard from 'react-step-wizard'
import './StepperStartUp.css'
import { StartUpStepperContextProvider } from '../../StartUpStepperContext'
import { StepUserInfo } from './StepUserInfo'
import { StepStartUpInfo } from './StepStartUpInfo'
import { StepResponse } from './StepResponse'
import 'animate.css';
import { EndStepper } from '../../../sharedComponents'
import { StepperTemplate } from '../../../../../../templates'
import { LoginType } from 'components/types/Context'

export const StepperStartUp = () => {

    let custom = {
        enterRight: '',
        enterLeft: '',
        exitRight: '',
        exitLeft: '',
        intro: ''
    }

    return (
        <StartUpStepperContextProvider>
            <StepperTemplate>
                    <StepWizard transitions={custom} className='w-100'  >
                        <StepUserInfo />
                        <StepStartUpInfo />
                        <StepResponse />
                        <EndStepper loginType={LoginType.startup} />
                    </StepWizard>
                </StepperTemplate>
        </StartUpStepperContextProvider>
    )
}
